module.exports = __webpack_public_path__ + "img/9.ff87b6a9.png";